import React from 'react'
import { TWAppDownloadDigitalEditionBlock } from '../TWAppDownloadDigitalEditionBlock/TWAppDownloadDigitalEditionBlock'
import { TWAppDownloadHeroBlock } from '../TWAppDownloadHeroBlock/TWAppDownloadHeroBlock'
import { TWAppDownloadPuzzlesBlock } from '../TWAppDownloadPuzzlesBlock/TWAppDownloadPuzzlesBlock'
import { TWStayInformedBlock } from '../TWStayInformedBlock/TWStayInformedBlock'

export function TWAppDownloadPage() {
    return (
        <>
            <TWAppDownloadHeroBlock />
            <TWAppDownloadDigitalEditionBlock />
            <TWAppDownloadPuzzlesBlock />
            <TWStayInformedBlock />
        </>
    )
}
